import _ from 'lodash';
import { ProductType } from '../../components/ticket/ticket.constants';

export class BaseController {
  constructor(injections, options) {
    // Assign given injections to the controllers instance
    this.constructor.injectArguments(this, injections, options);

    // Ensure that the mandatory controllerSevice has been injected
    this.constructor.contractInjection(this, 'controllerService');

    // Set initial languageOptions once
    if (!this.languageOptions) {
      this.setLanguageOptions();
    }
    this.validationMessages = {
      required: 'app.validation.required',
    };
  }

  get $log() {
    return this.controllerService.$log;
  }

  get $locale() {
    return this.controllerService.$locale;
  }

  get $location() {
    return this.controllerService.$location;
  }

  get $translate() {
    return this.controllerService.$translate;
  }

  get $state() {
    return this.controllerService.$state;
  }

  get $stateParams() {
    return this.controllerService.$stateParams;
  }

  get $timeout() {
    return this.controllerService.$timeout;
  }

  get $window() {
    return this.controllerService.$window;
  }

  get config() {
    return this.appConfig;
  }

  get appConfig() {
    return this.controllerService.appConfig;
  }

  get appCache() {
    return this.controllerService.appCache;
  }

  get appService() {
    return this.controllerService.appService;
  }

  get authService() {
    return this.controllerService.authService;
  }

  get envService() {
    return this.controllerService.envService;
  }

  get errorService() {
    return this.controllerService.errorService;
  }

  get errorTrackingService() {
    return this.controllerService.errorTrackingService;
  }

  get custom() {
    return this.controllerService.envService.custom;
  }

  get stateName() {
    return this.$state.current.name;
  }

  get userService() {
    return this.controllerService.userService;
  }

  get featureFlags() {
    return this.controllerService.featureFlagService.featureFlags;
  }

  get FeatureNames() {
    return this.controllerService.featureFlagService.FeatureFlagNames;
  }

  get isDWS() {
    return this.$stateParams.product === ProductType.DWS;
  }

  get isKWS() {
    return this.$stateParams.product === ProductType.KWS;
  }

  isFeatureActive(feature) {
    return this.controllerService.featureFlagService.isFeatureActive(feature);
  }

  error(error) {
    this.constructor.contractInjection(this, 'errorService');
    this.errorService.error(error);
  }

  get tenantGroup() {
    return this.envService.tenantGroup;
  }

  getConfig() {
    return this.config;
  }

  getConfigItem(key, defaultValue) {
    return _.get(this.config, key, defaultValue);
  }

  go(to, params = {}, options = {}) {
    this.constructor.contractInjection(this, '$state');

    // Ensure that the given parameters are splitted
    // to the target state and its parameters. If the
    // given to parameter contains a state object, we
    // have to deconstruct this object first.
    if (to.state) {
      params = _.merge(to.params || {}, params);
      to = to.state.name;
    }

    if (options.silent) {
      return this.$state.go(to, params, { location: 'replace' });
    }
    this.$state.go(to, params);
  }

  goBack() {
    this.constructor.contractInjection(this, '$window');
    this.$window.history.back();

    // Support native app history
    if (navigator && navigator.app) {
      navigator.app.backHistory();
    }
  }

  notFound() {
    this.constructor.contractInjection(this, '$state');
    return this.$state.go('notFound');
  }

  reload(params) {
    this.go(this.$state.current, params);
  }

  bindTranslationChange(rootScope) {
    rootScope.$on('$translatePartialLoaderStructureChanged', () => {
      this.setLanguageOptions();
    });
  }

  setLanguageOptions() {
    const lang = this.$translate.use();
    const { longDate, mediumDate, shortDate } = this.$locale.DATETIME_FORMATS;
    this.languageOptions = {
      lang,
      dateFormat: mediumDate,
      longDate,
      mediumDate,
      shortDate,
    };
    return this.controllerService.tmhDynamicLocale.set(lang);
  }
}
